import { L2Target } from '@resistapp/common/assays';
import { MinorTarget } from '@resistapp/common/assays-temp-96-gene-minor-targets';
import { MetricMode } from '@resistapp/common/types';

export enum KeyInsightCategory {
  OVERALL = 'OVERALL',
  ANTIBIOTIC = 'ANTIBIOTIC',
  PATHOGEN = 'PATHOGEN',
  POLLUTION = 'POLLUTION',
  MGE = 'MGE',
  CHALLENGE = 'CHALLENGE',
}

export enum KeyInsightValence {
  POSITIVE = 'POSITIVE',
  NEGATIVE = 'NEGATIVE',
  NEUTRAL = 'NEUTRAL', // Added neutral for informational bullets
}

export interface InsightSelect {
  month?: Date; // Jump to this month in trend chart
  l2Target?: L2Target; // Sets queryFilters.setSelectedTargetsStable([..])
  minorTarget?: MinorTarget; // e.g., PATHOGEN
  assay?: string; // Single gene if needed
}

export interface InsightBullet {
  id: string; // stable, kebab-cased identifier
  category: KeyInsightCategory;
  valence: KeyInsightValence;
  text: string; // User-facing sentence
  select?: InsightSelect;
  children?: InsightBullet[]; // Added for nested bullets
}

export interface KeyInsights {
  siteEnvId: number; // environment.id of the site
  metricMode: MetricMode; // The metric mode these insights apply to
  bullets: InsightBullet[]; // Ordered list shown to the user
}
